import { Controller } from "@hotwired/stimulus"

// The New API key page's scopes: ticking an area (or Full access) ticks its scopes, and unticking one of
// them unticks the area, so what's shown is what the key gets. The server expands areas and Full access
// on its own, so the form works without this.
export default class extends Controller {
  static targets = ["full", "group", "all", "scope"]

  toggleFull() {
    this.scopeTargets.forEach((box) => { box.checked = this.fullTarget.checked })
    this.allTargets.forEach((box) => { box.checked = this.fullTarget.checked })
  }

  toggleGroup(event) {
    const group = event.target.closest("[data-scope-groups-target='group']")
    group.querySelectorAll("[data-scope-groups-target='scope']").forEach((box) => { box.checked = event.target.checked })
    this.sync()
  }

  toggleScope() {
    this.sync()
  }

  sync() {
    this.groupTargets.forEach((group) => {
      const scopes = [...group.querySelectorAll("[data-scope-groups-target='scope']")]
      group.querySelector("[data-scope-groups-target='all']").checked = scopes.every((box) => box.checked)
    })
    this.fullTarget.checked = this.scopeTargets.every((box) => box.checked)
  }
}
